// src/components/project/SKIPER/chapters/WhyAntarctica.jsx
import React from 'react';
import objodec from '../../../../images/objodec2.png';
import antartica from '../../../../images/antartica.jpeg';

export default function WhyAntarctica() {
  return (
    <section id="why-antartica-content" className="chapter-section content-section">
      <div className="chapter-content">
 
        
        <h1 className="content-title">Why Antarctica?</h1>
        <p>
        Antarctica is more than just ice — it’s a global lab of the unknown. Harsh, remote, and barely touched by humans, 
        it's one of the most extreme environments on Earth. For Chile, a country with territorial presence and scientific responsibility in the region, 
        exploring Antarctica isn’t just a challenge — it’s a commitment.
        </p>
        <img src={objodec} alt="ObjetivosOdec" style={{ width: '50%', height: 'auto' }} className="chapter-image"/> 


        <p>
         At Hero Dynamics, we see it as the ultimate testing ground. If our technology can survive here, it can survive anywhere.
        </p>

        <p>
        But more than that, Antarctica is a natural archive of life’s most resilient strategies. 
        In its frozen depths and silent waters lie forms of adaptation that could inspire solutions to problems far beyond the poles — from climate resilience to new materials and energy systems.
        </p>
        <img src={antartica} alt="antartica" className="chapter-image"/>
        <p>
         We believe this kind of exploration must be done with care. That’s why we build biomimetic robots that don’t disrupt but adapt. If our robots can survive there, they can survive anywhere.
        </p>

        <p>
         At Hero Dynamics, we craft biomimetic tools for scientists, explorers, and environmental defenders — giving them gear worthy of their mission. 
         We’re here to understand it — and help others protect it. 
        </p>

        <p>
         We believe the future of exploration belongs to those who explore with respect.
        </p>


      </div>
    </section>
  );
}
